import React from 'react';
import { MdGroups } from 'react-icons/md';
import { FaUserTie, FaBuilding, FaUserCircle } from 'react-icons/fa';
import './Committees.css';

const Committees = () => {
  const organizingCommittee = [
    { role: 'Patron', name: 'Dr. B.S. Murty', affiliation: 'Director - IIITDM Kurnool', img: '/director.jpeg' },
    { role: 'Chairperson', name: 'Dr. T Pandiyarajan', affiliation: 'Head, Dept. of Sciences', img: '/pandiyarajan.png' },
    { role: 'Convenor', name: 'Dr. Pavan Venu Prakash Madduri', affiliation: 'Asst. Prof., Department of Sciences', img: '/prakashmadduri.png' },
    { role: 'Convenor', name: 'Dr. Putha Kishore', affiliation: 'Asst. Prof., Department of Sciences', img: '/putha.png' },
    { role: 'Organizing Committee', name: 'Dr. D Murali', affiliation: 'Assoc. Prof. DoS-IIITDM K', img: '/dmurali.png' },
    { role: 'Organizing Committee', name: 'Dr. D. Amarantha Reddy', affiliation: 'Assoc. Prof. DoS-IIITDM K', img: '/amarnath.png' },
    { role: 'Organizing Committee', name: 'Dr. Joy Mukherjee', affiliation: 'Asst. Prof. DOS-IIITDM K', img: '/JoyMukarji.png' },
  ];

  const advisoryCommittee = [
    { name: 'Prof. S. Srinath', affiliation: 'University of Hyderabad', img: '/SSrinath.avif' },
    { name: 'Prof. J. Suryanarayana', affiliation: 'IIT Hyderabad', img: '/suryanarayana-j.avif' },
    { name: 'Prof. B R K Nanda', affiliation: 'IIT Madras', img: '/Birabar-Nanda.avif' },
    { name: 'Prof. B. Karthikeyan', affiliation: 'NIT Tiruchirappalli, India', img: '/bkarthik.png' },
    { name: 'Prof. G. Hema Chandra', affiliation: 'VNIT Nagpur', img: '/ghemachandra.png' },
    { name: 'Prof. D. Dinakar', affiliation: 'NIT Warangal', img: '/dinkar.png' },
    { name: 'Prof. Sourabh Roy', affiliation: 'NIT Warangal', img: '/sourabhroy.png' },
    { name: 'Dr. Basheed', affiliation: 'CSIR-NPL, Delhi', img: '/basheed.png' },
    { name: 'Dr. Koteswara Rao', affiliation: 'IIT Tirupati', img: '/koteshwarrao.png' },
    { name: 'Prof. M. V. Shankar', affiliation: 'Yogi Vemana University-Kadapa', img: '/mv_shankar.png' },
    { name: 'Prof. K. Sathya Babu', affiliation: 'IIITDM Kurnool', img: '/sathyababu.png' },
    { name: 'Dr. J. Krishnaiah', affiliation: 'IIITDM Kurnool', img: '/krishnaiah.png' },
    { name: 'Dr. S. Anand Kumar', affiliation: 'IIITDM Kurnool', img: '/anandkumar.png' },
    { name: 'Dr. P. Rangababu', affiliation: 'IIITDM Kurnool', img: '/rangababu.jpg' },
    { name: 'Dr. K. V. Eswaramoorthy', affiliation: 'IIITDM Kurnool', img: '/eswara.png' },
  ];

  return (
    <div className="committees-page">
      

      <div className="committees-container">
        <section className="committees-section" id="organising">
          <div className="committees-section-header-simple">
            <h2 className="committees-subtitle">Organising Committee</h2>
          </div>
          <div className="committees-grid">
            {organizingCommittee.map((member, index) => (
              <div className="committees-card committees-member-card" key={index}>
                <div className="committees-card-top-accent"></div>
                {member.img ? (
                  <img src={member.img} alt={member.name} className="committees-member-image" />
                ) : (
                  <div className="committees-member-placeholder">
                    <FaUserCircle />
                  </div>
                )}
                <div className="committees-member-role-badge">{member.role}</div>
                <h4 className="committees-member-name">{member.name}</h4>
                <div className="committees-member-affiliation">
                  <FaBuilding className="committees-aff-icon" />
                  <span className="committees-affiliation-text">{member.affiliation}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="committees-section committees-bg-light-section" id="advisory">
          <div className="committees-section-header-simple">
            <h2 className="committees-subtitle">Advisory Committee</h2>
          </div>
          <div className="committees-grid committees-advisory-grid">
            {advisoryCommittee.map((member, index) => (
              <div className="committees-card committees-advisory-card" key={index}>
                {member.img ? (
                  <img src={member.img} alt={member.name} className="committees-member-image" />
                ) : (
                  <div className="committees-member-placeholder-advisory">
                    <FaUserCircle />
                  </div>
                )}
                <h4 className="committees-member-name">{member.name}</h4>
                <div className="committees-member-affiliation">
                  <FaBuilding className="committees-aff-icon" />
                  <span className="committees-affiliation-text">{member.affiliation}</span>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Committees;
